var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_677_3433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.125 7.08333C2.125 7.73447 2.25325 8.37923 2.50243 8.98081C2.75161 9.58238 3.11684 10.129 3.57726 10.5894C4.03769 11.0498 4.58429 11.4151 5.18586 11.6642C5.78743 11.9134 6.4322 12.0417 7.08333 12.0417C7.73447 12.0417 8.37923 11.9134 8.98081 11.6642C9.58238 11.4151 10.129 11.0498 10.5894 10.5894C11.0498 10.129 11.4151 9.58238 11.6642 8.98081C11.9134 8.37923 12.0417 7.73447 12.0417 7.08333C12.0417 6.4322 11.9134 5.78743 11.6642 5.18586C11.4151 4.58429 11.0498 4.03769 10.5894 3.57726C10.129 3.11684 9.58238 2.75161 8.98081 2.50243C8.37923 2.25325 7.73447 2.125 7.08333 2.125C6.4322 2.125 5.78743 2.25325 5.18586 2.50243C4.58429 2.75161 4.03769 3.11684 3.57726 3.57726C3.11684 4.03769 2.75161 4.58429 2.50243 5.18586C2.25325 5.78743 2.125 6.4322 2.125 7.08333Z",
    stroke: "#757373",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.875 14.875L10.625 10.625",
    stroke: "#757373",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_677_3433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchGrey);
export default __webpack_public_path__ + "static/media/Icon_Search_Grey.df997ce061bb285d09369eab299a2592.svg";
export { ForwardRef as ReactComponent };